// v.price is already shaped by the API for the current locale; never derive one market's price from the other.
export const formatPrice = (v, t) => (v.price?.amount == null ? t("vehicle.ask") : `¥${v.price.amount.toLocaleString("en-US")}`);

export const priceNote = (v, t) => {
  const p = v.price;
  if (!p || p.hidden) return "";
  if (p.kind === "japan") return p.amount != null ? t("price.exclTax") : "";
  return t("price.shipping");
};

export const formatMileage = (km) => `${km.toLocaleString("en-US")} km`;

export const coverImage = (v) =>
  v.cover_image || v.images?.find((i) => i.id === v.cover_image_id) || v.images?.[0] || null;

export const vehicleTitle = (v) => [v.make, v.model, v.grade].filter(Boolean).join(" ");

export const fmt = (template, vars) => template.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? "");

export const formatPriceShort = (yen, lang) =>
  lang === "ja" ? `${(yen / 10000).toLocaleString("ja-JP")}万円` : `¥${(yen / 1_000_000).toLocaleString("en-US")}M`;

// Clean vehicle URL for sharing; link-preview crawlers are routed to /api/og/vehicles/{slug} by server/edge.js.
let siteUrl = process.env.REACT_APP_SITE_URL;
// Backend SITE_URL (from /settings/public) overrides the build-time value, so test hosts need no rebuild.
export const setSiteUrl = (u) => { if (u) siteUrl = u.replace(/\/$/, ""); };
export const siteBase = () => siteUrl;
export const publicVehicleUrl = (lang, slug) => `${siteUrl}/${lang}/inventory/${slug}`;
